import { Directive, ElementRef, Input, OnInit, HostListener } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({
  selector: '[phoneMask]'
})

export class PhoneMaskDirective implements OnInit {

  private _phoneControl!: AbstractControl;

  @Input()
  set phoneControl(control: AbstractControl){
    this._phoneControl = control;
  }

  constructor(private el: ElementRef) {}

  @HostListener("input", ['$event']) onInput(e: InputEvent) {
    this.phoneValidate(e);
  }

  @HostListener("keydown", ['$event']) onPhoneKeyDown(event: KeyboardEvent) {
    // Clear input after remove last symbol
    let inputValue = (event.target as HTMLInputElement)?.value.replace(/\D/g, '');
    if (event?.key == '8' && inputValue.length == 1) {
      (event.target as HTMLInputElement).value = "";
    }

  }

  @HostListener("paste", ['$event']) onPhonePaste(event: ClipboardEvent) {
    let input = event.target as HTMLInputElement,
        getNumsValue = (val: string) => val.replace(/\D/g, ''),
        numsValue = getNumsValue(input?.value);

    var pasted = event.clipboardData || (<any>window).clipboardData;
    if (pasted) {
        var pastedText = pasted.getData('Text');
        if (/\D/g.test(pastedText)) {
            // Attempt to paste non-numeric symbol — remove all non-numeric symbols,
            // formatting will be in onPhoneInput handler
            input.value = numsValue;
            return;
        }
    }
  }

  ngOnInit(){
    this.phoneValidate();
  }

  phoneValidate(e?: InputEvent){
    let input = this.el.nativeElement,
        getNumsValue = (val: string) => val.replace(/\D/g, ''),
        numsValue = getNumsValue(input.value),
        selectionStart = input.selectionStart,
        formattedValue = "";

    if(!numsValue && input.value != "+") return this._phoneControl.setValue(null, {emitEvent: false});

    if (input.value.length != selectionStart) {
      // Editing in the middle of input, not last symbol
      if (e?.data && /\D/g.test(e.data)) {
          // Attempt to input non-numeric symbol
          input.value = numsValue;
      }
      return;
    }

    if (["7", "8", "9"].indexOf(numsValue[0]) > -1) {
      if (numsValue[0] == "9") numsValue = "7" + numsValue;

      var firstSymbols = "+7";

      formattedValue = input.value = firstSymbols;

      if (numsValue.length > 1) formattedValue += ' (' + numsValue.substring(1, 4);

      if (numsValue.length >= 5) formattedValue += ') ' + numsValue.substring(4, 7);

      if (numsValue.length >= 8) formattedValue += '-' + numsValue.substring(7, 9);

      if (numsValue.length >= 10) formattedValue += '-' + numsValue.substring(9, 11);
    } else {
      formattedValue = '+' + numsValue.substring(0, 16);
    }

    input.value = formattedValue;
    this._phoneControl.setValue(input.value, {emitEvent: false});
  }
}
